module.exports = __webpack_public_path__ + "img/D2_HQ02.c084f0c8.jpg";